<template>
  <alzata-dialog
    ref="modal"
    :title="admin?.userId ? 'Edit Admin' : 'Create Admin'"
  >
    <div class="row g-2">
      <div class="col-12">
        <label for="firstname" class="small">First Name</label>
        <input
          id="firstName"
          type="text"
          class="form-control"
          placeholder="First Name"
          v-model="firstName"
        />
        <label for="lastName" class="small">Last Name</label>
        <input
          id="lastName"
          type="text"
          class="form-control"
          placeholder="Last Name"
          v-model="lastName"
        />
        <label for="email" class="small">Email / Username</label>
        <input
          id="email"
          type="email"
          class="form-control"
          :class="{ 'is-invalid': errors.emailuser || errors.emailInUse }"
          placeholder="Email / Username"
          v-model="email"
        />
        <div v-if="errors.emailInUse" class="invalid-feedback">
          Email has already been registered.
        </div>
        <div v-if="errors.emailuser" class="invalid-feedback">
          Email/Username is required.
        </div>
        <label for="phone" class="small">Phone Number</label>
        <input
          id="phone"
          type="phone"
          class="form-control"
          placeholder="Phone Number"
          v-model="phoneNumber"
        />
        <div v-if="!veteran?.userId">
          <label for="password" class="small">Password</label>
          <input
            id="password"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.password }"
            placeholder="Password"
            v-model="password"
          />
          <div v-if="errors.password" class="invalid-feedback">
            Password is required to be at least 6 characters, have at least one non alphanumeric character, have at least one upper case character, and have at least one lower case character.
          </div>
        </div>
      </div>
    </div>
    <template v-slot:modal-footer>
      <button type="button" class="btn btn-link" @click="hideEditAdmin">
        Cancel
      </button>
      <button type="button" class="btn btn-primary" @click="save">Save</button>
    </template>
  </alzata-dialog>
</template>

<script>
import { doGet } from "../apis/baseApiClient";

export default {
  name: "EditAdminDialog",
  emits: ["save"],
  data() {
    return {
      admin: null,
      firstName: null,
      lastName: null,
      email: null,
      phoneNumber: null,
      password: null,
      errors: {
        emailuser: false,
        password: false,
        emailInUse: false,
      },
    };
  },
  methods: {
    clearValidation() {
      this.errors.emailuser = false;
      this.errors.password = false;
    },
    show(admin) {
      this.admin = admin;
      this.firstName = admin.firstName;
      this.lastName = admin.lastName;
      this.email = admin.email;
      this.phoneNumber = admin.phoneNumber;
      this.password = null;
      
      this.clearValidation();

      this.$refs.modal.show();
    },
    hideEditAdmin() {

      this.clearValidation();
      this.$refs.modal.hide();
    },
    async save() {

      this.errors.emailInUse = "true" == await (await doGet("/api/v1/profiles/user-exists/" + encodeURIComponent(this.email))).text();

      const needsPassword = !this.admin.userId;
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{6,}$/;

      if(needsPassword){
        this.errors.password = !this.password || !passwordRegex.test(this.password);
      }

      this.errors.emailuser = !this.email;
      
      if (this.errors.password || this.errors.emailuser || this.errors.emailInUse) {
        return;
      }

      this.$emit("save", {
        userId: this.admin.userId,
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        phoneNumber: this.phoneNumber,
        password: this.password,
      });
    },
  },
};
</script>
